import { useRef } from 'react'
import { DigitalDataOrigin } from '@dustin-web/product-components/src/utils/digital-data-types'
import {
  EventListType,
  ProductDigitalData,
} from '@dustin-web/product-components/src/utils/product-digital-data'
import { newRelicLogger } from '@dustin-web/microsite-config/src/newrelic/logger'

export type ProductGA4UnbouncedAddToCart = EventListType & {
  label?: string[] | null | undefined
  digitalDataOrigin?: DigitalDataOrigin | undefined
  digitalDataCartIndex?: number | undefined
}

export const useDebouncedAddToCart = () => {
  const dataLayer = useRef<ProductGA4UnbouncedAddToCart[]>([])
  const debouncedPush = debounce(() => {
    let isBlocked = false
    if (dataLayer.current.length > 0) {
      if (dataLayer.current.length > 10) {
        console.log('More than 10 events detected in less than 2 seconds.')
        newRelicLogger.error(
          {
            origin,
            eventName: 'add_to_cart',
            eventCount: dataLayer.current.length,
            addingElementOrigin: 'buyButton',
          },
          'More than 10 events detected in less than 2 seconds.'
        )
        isBlocked = true
      }
      if (dataLayer.current.some(x => x.quantity != null && x.quantity > 1000)) {
        console.log('More than 1000 in quantity of an event detected in less than 2 seconds.')
        newRelicLogger.error(
          { origin, eventName: 'add_to_cart', addingElementOrigin: 'buyButton' },
          'More than 1000 in quantity of an event detected in less than 2 seconds.'
        )
        isBlocked = true
      }

      if (!isBlocked) {
        console.log('Event pushAddMultipleProductsCartEvent not blocked')
        ProductDigitalData.pushAddMultipleProductsCartEvent(
          dataLayer.current,
          dataLayer.current[0].digitalDataOrigin,
          'buyButton',
          dataLayer.current[0].digitalDataCartIndex
        )
      }
    }
    dataLayer.current = []
    isBlocked = false
  }, 2000)

  return (products: ProductGA4UnbouncedAddToCart[]) => {
    dataLayer.current.push(...products)
    debouncedPush()
  }
}

function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout
  return (...args: Parameters<T>) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), wait)
  }
}
